import { faExclamationCircle, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { linksUrl } from "../constants/enum";
import { useDisclosure } from "@heroui/react";
import { setLogout } from "../state/authSlice";
import { resetCompCode } from "../state/companySlice";

function ErrorCard() {
  const { compCode } = useSelector((state) => state.company)
  const { isAuthenticated, user, tokenExpiry, token } = useSelector((state) => state.auth)
  //console.log(isAuthenticated, user, compCode, toke)
  const dispatch = useDispatch();
  const navi = useNavigate()

  const handleClick = () => {
    if (tokenExpiry && tokenExpiry != "") {
      const currentTime = new Date().getTime() / 1000;
      if (currentTime > tokenExpiry || !isAuthenticated) {
        dispatch(setLogout())
        dispatch(resetCompCode())
        navi(linksUrl.login)
        // window.location.href = linksUrl.login;
      }
      else {
       // console.log("hi")
          window.location.reload();
      }
    }
    else {
      dispatch(setLogout())
      dispatch(resetCompCode())
      navi(linksUrl.login)

    }
  }
  return (
    <div className="bg-red-100 px-6 py-4 my-4 rounded-md text-lg flex gap-4 border-1  border-red-200  items-center mx-auto max-w-lg">
      <FontAwesomeIcon
        icon={faExclamationCircle}
        className="text-red-600 text-2xl"
      />
      <span className="text-red-600">
        <div className="text-sm">Something went wrong ! <span on onClick={handleClick} className="text-sm text-Rose-700 mx-5  bg-red-200 p-1 cursor-pointer text-xs  rounded-md" > Click To Reconnect</span> </div>
      </span>
      {/* {isAuthenticated && user && compCode && compCode.length <= 0 ? 
        (<div className="text-sm">Select Company  ! <Link to={linksUrl.companies} style={{ color: "#eb8b0e" }} className="text-sm text-Rose-700" >Click Here</Link> </div>) :
        
         ):<div className="text-sm">Something went wrong !</div>} */}

    </div>
  )
}
export default ErrorCard